export function redirectToWebUploader(uploaderUrl: string) {
  window.open(uploaderUrl);
}
